

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CCzrn5mw.js","_app/immutable/chunks/disclose-version.DJVJNQBy.js","_app/immutable/chunks/runtime.Bk3K0l7O.js","_app/immutable/chunks/legacy.D3eNFHPr.js","_app/immutable/chunks/render.Cvm6B7jA.js","_app/immutable/chunks/svelte-head.DZ8I8gWJ.js","_app/immutable/chunks/lifecycle.JwKvXvYo.js","_app/immutable/chunks/entry.BU-Ash6O.js","_app/immutable/chunks/index-client.BvveTgYa.js"];
export const stylesheets = [];
export const fonts = [];
